var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskToolsExportsBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.952,51.3V33h75V51.3h-27V135h-20.7V51.3Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.072,127.388q-6.669,8.874-22.942,8.872t-22.942-8.872q-6.671-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187t22.942,9.187q6.667,9.191,6.668,28.088T141.072,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T129.68,80.82q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T106.527,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.432,127.388q-6.669,8.874-22.943,8.872t-22.942-8.872q-6.669-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187t22.943,9.187q6.666,9.191,6.667,28.088T207.432,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.15-18.848q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T172.887,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.023,135H224.388V63.6h14.49V122.19h26.145Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.792,74.94q-11.446,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.835,1.785,13.282,5.144t14.648,7.612q4.2,4.252,4.2,13.074,0,11.237-6.825,17.009t-17.85,5.775a99.321,99.321,0,0,1-20.055-2.52l-3.78-.735,1.469-11.234A174.956,174.956,0,0,0,291.8,123.66q11.127,0,11.13-9.24a6.151,6.151,0,0,0-2.573-5.25q-2.574-1.89-10.237-4.095-12.182-3.463-17.168-8.242T267.961,83.55q0-10.71,6.511-15.96t17.85-5.25a118.717,118.717,0,0,1,19.74,2.1l3.78.735L314.687,76.62Q299.882,74.942,293.792,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.144,34.275q8.4-6.073,22.725-6.075t22.275,6.225q7.948,6.227,7.95,17.025t-4.5,16.95q-4.5,6.153-16.05,14.25l14.7,14.7a44.009,44.009,0,0,0,1.8-8.7q.9-6.447,1.05-10.5l19.5.451a119.9,119.9,0,0,1-7.65,30.449l16.8,14.7-11.4,13.05-15.9-13.05a40.547,40.547,0,0,1-13.425,9.375,41.8,41.8,0,0,1-17.325,3.675q-21.9,0-31.125-7.875T354.344,105.6q0-12.151,5.1-19.125t16.2-11.326q-6.153-7.5-8.025-12.15a32.92,32.92,0,0,1-1.875-12.149A19.371,19.371,0,0,1,374.144,34.275Zm18,84.525a41.814,41.814,0,0,0,11.7-1.65q5.7-1.649,7.95-4.35l-25.95-25.949q-11.1,5.4-11.1,17.1Q374.744,118.8,392.144,118.8Zm-6-63.449q0,6,6.75,13.2l2.55,2.7a40.128,40.128,0,0,0,8.7-8.024,14.078,14.078,0,0,0,2.55-8.476q0-9.45-10.275-9.45T386.144,55.351Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.34,135V33h66V51h-45.3V74.851h36.3v17.7h-36.3V117h45.3v18Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.348,63.6l13.23,26.25L605.123,63.6h15.015l-20.58,36.434L620.138,135H604.073l-13.23-24.675L577.3,135H562.283l20.58-34.229L562.283,63.6Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,114.21h-11.76V135h-14.49V63.6H653q25.41,0,25.411,24.779,0,12.5-6.458,19.163T653,114.21Zm-11.76-12.39H652.9q10.814,0,10.815-13.44,0-6.613-2.625-9.5T652.9,75.99H641.241Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.9,127.388q-6.668,8.874-22.942,8.872t-22.942-8.872q-6.671-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187T735.9,71.527q6.667,9.191,6.668,28.088T735.9,127.388Zm-34.544-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.15-18.848q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T701.353,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.344,111.061V135h-14.49V63.6h27.721q25.2,0,25.2,23.519,0,13.966-10.5,20.58L805.459,135H789.6l-8.294-23.939Zm21.106-15.54a12.89,12.89,0,0,0,2.519-8.3,11.964,11.964,0,0,0-2.677-8.191q-2.678-3.043-7.717-3.045H767.344V98.67h13.441Q785.927,98.67,788.45,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.449,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.927,74.94q-11.445,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.836,1.785,13.283,5.144t14.648,7.612q4.2,4.252,4.2,13.074,0,11.237-6.824,17.009t-17.851,5.775a99.33,99.33,0,0,1-20.055-2.52l-3.779-.735,1.469-11.234a174.941,174.941,0,0,0,21.526,1.889q11.127,0,11.129-9.24a6.15,6.15,0,0,0-2.572-5.25q-2.574-1.89-10.238-4.095-12.181-3.463-17.167-8.242T865.1,83.55q0-10.71,6.51-15.96t17.851-5.25a118.706,118.706,0,0,1,19.739,2.1l3.781.735L911.822,76.62Q897.018,74.942,890.927,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskToolsExportsBanner);
export default __webpack_public_path__ + "static/media/BreachRisk_Tools_Exports_Banner.8cfdae4e8ceadf74e18d3ad0efe8f069.svg";
export { ForwardRef as ReactComponent };